let nextCase;

export class NextCase {
    constructor() {
        this.$nextCase = App.H.find('.js-next-case');

        this.bindNextCase();

    }

    bindNextCase() {
        this.$nextCase.find(".js-title-screen").css('opacity', '0');
        this.$nextCase.on('click', () => {

            this.$nextCase.find(".js-first-screen-footer").removeClass('first-screen--footer');
            this.$nextCase.find(".js-first-screen").css('transform', 'translateY(0)').css('height', '100%');
            this.$nextCase.addClass('case-siblings__next');

            setTimeout(() => {
                this.$nextCase.find(".js-title").css('position', 'absolute');
                this.$nextCase.find(".js-first-screen").css('position', 'relative');
                this.$nextCase.removeClass('case-siblings--hover');
            }, 1000);

            setTimeout(() => {
                App.H.animate({scrollTop: App.D.height()}, 2000);
                this.$nextCase.find(".section-title").css('opacity', '0');
            }, 2000);
        });
    }
}

App.W.on('barba:afterEnter', () => {
    nextCase = new NextCase();
});

App.W.on('barba:leave', () => {
    try {
        nextCase.destroy();
    } catch(error) { }
});


// WEBPACK FOOTER //
// ./_src/js/modules/NextCase.js